export async function fetchConfig() {
  const response = await fetch("https://menumind.smcare.net/constants.json");
  const config = await response.json();
  console.log(config);
}

// export const baseUrl = "https://electro.smcare.net/tsb/api";
export const baseUrl = "https://electro.smcare.net/port79/api/";


// https://electro.smcare.net/tcp/api/
// https://electro.smcare.net/dose/api/